import { rootApi } from '../../../../app/stores/baseQuery';
import { CommonRequest, CommonResponse } from '../../../../shared/model/api/types';
import { TaskDto, TaskResponse, UpdateTasksDataDto } from '../../../../shared/model/tasks/types';

export const taskApi = rootApi.enhanceEndpoints({ addTagTypes: ['Task'] }).injectEndpoints({
  endpoints: (builder) => ({
    getTask: builder.query<TaskDto, string>({
      query: (id: string) => ({
        url: `gettask?task_id=${id}`,
      }),
      providesTags: () => ['Task'],
      transformResponse: (result: TaskResponse): TaskDto => {
        return result.GetTaskResult.data.message;
      },
      transformErrorResponse(error) {
        console.error('gettask: ', error);
        return error.data;
      },
    }),
    markAsViewed: builder.query<void, string>({
      query: (id: string) => ({
        url: `markasviewed?task_id=${id}`,
      }),
    }),
    updateTask: builder.mutation<CommonResponse<boolean>, CommonRequest<UpdateTasksDataDto>>({
      query: (body) => ({
        body,
        method: 'POST',
        url: 'updatetask',
      }),
    }),
  }),
});

export const { useGetTaskQuery, useMarkAsViewedQuery, useUpdateTaskMutation } = taskApi;
